import React, { useEffect, useRef, useState } from 'react'

import {
  Box,
  Chip,
  Hidden,
  Paper,
  Tab,
  TablePagination,
  Tabs,
} from '@material-ui/core'
import PerfectScrollbar from 'react-perfect-scrollbar'

import { LoadingFeedback } from 'components'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'
import { ActionButtons } from './components'

import useFetch from 'hooks/useFetch'
import usePagination from 'hooks/usePagination'

import constants from 'constants/index'
import helpers from 'helpers'
import * as service from 'service'

import useStyles from './styles'

// Listagem dos projetos. O service e as ações da linha vêm por prop para o app e
// o portal de convidados compartilharem a tabela: o app filtra pelo enum das
// TABS e o portal pelo label do status (STATUS_LABEL_TABS).
const PrivacyByDesignTable = ({
  listService = service.dponet.privacyByDesign.get,
  tabs = constants.privacyByDesign.TABS,
  params = {},
  renderActions,
  id = constants.privacyByDesign.PRIVACY_BY_DESIGN_DRIVER_STEP_2,
  emptyMessage = 'Nenhum projeto de Privacy by Design encontrado.',
}) => {
  const [currentTab, setCurrentTab] = useState(null)
  const isFirstRender = useRef(true)

  const { STATUSES } = constants.privacyByDesign

  const classes = useStyles()

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(5)

  // Os params chegam num objeto novo a cada render do pai, então a dependência é
  // a versão serializada — do contrário a busca dispararia em loop.
  const serializedParams = JSON.stringify(params)

  const { response, isLoading, refresh } = useFetch(
    listService,
    { ...params, perPage, page, status: currentTab },
    [serializedParams, perPage, page, currentTab],
  )

  const privacyByDesigns = response?.data?.privacyByDesigns || []

  const handleTabsChange = (event, value) => setCurrentTab(value)

  // Filtrar ou trocar de aba recomeça a paginação, para não parar numa página
  // inexistente no novo resultado. No primeiro render a página vem da URL e é
  // mantida.
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    handleChangePage(null, 0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serializedParams, currentTab])

  return (
    <>
      <LoadingFeedback open={isLoading} />
      <Paper id={id}>
        <Tabs
          onChange={handleTabsChange}
          scrollButtons="auto"
          value={currentTab}
          variant="scrollable"
          textColor="primary"
          indicatorColor="primary"
        >
          {tabs.map((tab) => (
            <Tab
              key={String(tab.value)}
              label={tab.label}
              value={tab.value}
              onClick={(event) => handleTabsChange(event, tab.value)}
            />
          ))}
        </Tabs>
        <Box width="100%" className={classes.tableWrapper}>
          <PerfectScrollbar
            options={{ wheelPropagation: false, useBothWheelAxes: true }}
          >
            <Table noWrap emptyMessage={emptyMessage}>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Nome do Projeto</TableCell>
                  <TableCell>Departamento</TableCell>
                  <TableCell>Última Alteração</TableCell>
                  <TableCell>Template do Questionário</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell align="right">Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {privacyByDesigns?.map((privacyByDesign) => (
                  <TableRow key={privacyByDesign.id}>
                    <TableCell>{privacyByDesign.id}</TableCell>
                    <TableCell>{privacyByDesign.name}</TableCell>
                    <TableCell>{privacyByDesign.department?.name}</TableCell>
                    <TableCell>
                      {helpers.formatters.ptBrFormatDateTime(
                        privacyByDesign.updatedAt,
                      )}
                    </TableCell>
                    <TableCell>{privacyByDesign.quizTemplate?.kind}</TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        className={classes[privacyByDesign.status]}
                        label={STATUSES[privacyByDesign.status]}
                      />
                    </TableCell>
                    <TableCell align="right">
                      {renderActions ? (
                        renderActions(privacyByDesign, refresh)
                      ) : (
                        <ActionButtons
                          privacyByDesign={privacyByDesign}
                          refresh={refresh}
                        />
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </PerfectScrollbar>
        </Box>
        <TablePagination
          component="div"
          count={response?.data?.meta?.totalCount || 0}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          page={page - 1}
          rowsPerPage={perPage}
          rowsPerPageOptions={[5, 10, 25, 100]}
          labelRowsPerPage={<Hidden smDown>Por página</Hidden>}
          nextIconButtonProps={{ size: 'small' }}
          backIconButtonProps={{ size: 'small' }}
        />
      </Paper>
    </>
  )
}

export default PrivacyByDesignTable
